<template>
  <div class="session-adjustments">
    <v-card text tile>
      <v-card-actions class="justify-space-between">
        <v-btn text @click="prevSlide">
          <v-icon>navigate_before</v-icon>
        </v-btn>
        <v-item-group v-model="onboarding" class="text-center" mandatory>
          <v-item
            v-for="n in localEvents.length"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn :input-value="active" icon @click="toggle">
              <v-icon :color="eventColor(n - 1)">fiber_manual_record</v-icon>
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn text @click="nextSlide">
          <v-icon>navigate_next</v-icon>
        </v-btn>
      </v-card-actions>

      <v-window v-model="onboarding">
        <v-window-item v-for="(event, i) in localEvents" :key="i" eager>
          <EventDetails
            :passed-event="event"
            :form-only="true"
            @change="updateEvent"
            @validated="receiveValidation"
          ></EventDetails>
        </v-window-item>
      </v-window>
    </v-card>
    <v-card>
      <v-card-actions>
        <v-btn outlined @click="$emit('previous')">
          {{ $t("app.buttons.previous") }}
        </v-btn>
        <v-spacer></v-spacer>
        <ConfirmButton
          :message-title="$t('scheduler.session.creation.confirm.title')"
          :message-body="$t('scheduler.session.creation.confirm.message')"
          :loading="processing"
          @confirm="send"
        ></ConfirmButton>
        <!-- TODO: For future implementation -->
        <!--<v-btn dark color="mdred lighten-1" @click="send">
          {{ $t("app.buttons.next") }}
        </v-btn>-->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import EventDetails from "@/modules/scheduler/components/Event/EventDetails";
import ConfirmButton from "@/components/utilities/ConfirmButton";
import { mapState } from "vuex";

export default {
  components: {
    EventDetails,
    ConfirmButton
  },

  props: {
    events: {
      type: Array,
      required: true
    },
    processing: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localEvents: [],
    onboarding: 0,
    invalidEvents: []
  }),

  computed: {
    ...mapState("toolbox/advanced-forms", ["valid"])
  },

  watch: {
    events: function(val) {
      this.localEvents = val;
    }
  },

  mounted: function() {
    this.$nextTick(function() {
      this.localEvents = this.events;
      this.$store.dispatch(
        "toolbox/advanced-forms/setFixedSize",
        this.localEvents.length
      );
    });
  },

  beforeDestroy: function() {
    this.$store.dispatch("toolbox/advanced-forms/clear");
  },

  methods: {
    updateEvent(event) {
      const index = this.localEvents.findIndex(ev => ev.id === event.id);
      const participations = this.localEvents[index].participations;
      this.localEvents[index] = event;
      this.localEvents[index].participations = participations;
    },

    receiveValidation(validation) {
      if (!validation.valid) {
        this.invalidEvents.push(validation.eventId);
      }
    },

    eventColor(n) {
      var self = this;
      var color = null;
      this.invalidEvents.forEach(id => {
        if (self.localEvents[n].id === id) {
          color = "error";
        }
      });
      return color;
    },

    send() {
      var self = this;
      this.invalidEvents = [];
      this.$store.dispatch("toolbox/advanced-forms/validate").then(() => {
        if (self.valid) {
          self.$emit("next", self.localEvents);
        }
      });
    },

    nextSlide() {
      if (this.onboarding != this.localEvents.length - 1) {
        this.onboarding++;
      }
    },

    prevSlide() {
      if (this.onboarding !== 0) {
        this.onboarding--;
      }
    }
  }
};
</script>
